import * as React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ContentContainer } from '@krispy/layout/web';
import * as KrispyTokens from '@krispy-tokens/blue';

const propTypes = {
  children: PropTypes.node,
  padding: PropTypes.oneOf(['regular', 'compact']),
  layout: PropTypes.oneOf(['fixed', 'auto']),
  numberOfLines: PropTypes.oneOf(['auto', 1, 2]),
  striped: PropTypes.bool,
};
const defaultProps = {
  padding: 'regular',
  layout: 'auto',
  numberOfLines: 'auto',
  striped: false,
};

const KrispyTable = styled.table`
  border-spacing: 0;
  font-family: ${KrispyTokens.KrispyTypographyFontfamily};
  color: ${KrispyTokens.KrispyColorElementsPrimaryOnlight};
  box-shadow: ${KrispyTokens.KrispyElevationShadowHoffset}px 
  ${KrispyTokens.KrispyElevationShadowVoffset}px 
  ${KrispyTokens.KrispyElevationShadowBlur}px 
  ${KrispyTokens.KrispyElevationShadowSpread}px 
  ${KrispyTokens.KrispyElevationShadowColorOnlight};
  border: 1px solid ${KrispyTokens.KrispyColorPaletteGray92}; 
  width: 100%;
  table-layout: ${({ layout }) => layout};
  -webkit-line-clamp: ${({ numberOfLines }) => (numberOfLines)};

  ${({ striped }) => striped && `
    tr:nth-child(even) {
      background-color: ${KrispyTokens.KrispyColorBackgroundSecondaryLight};
    }
  `}

  thead {
    box-shadow: ${KrispyTokens.KrispyElevationShadowHoffset}px 
    ${KrispyTokens.KrispyElevationShadowVoffset}px 
    ${KrispyTokens.KrispyElevationShadowBlur}px 
    ${KrispyTokens.KrispyElevationShadowSpread}px 
    ${KrispyTokens.KrispyElevationShadowColorOnlight};
  }

  td,
  th {
    padding: ${({ padding }) => (padding === 'compact' ? `${KrispyTokens.KrispySpacingElementsHdXlarge}px` : 'auto')};
    border-bottom: 1px solid ${KrispyTokens.KrispyColorPaletteGray92};
  }
`;

const Table = (props) => {
  const {
    children,
    padding,
    layout,
    numberOfLines,
    striped,
  } = props;

  return (
    <ContentContainer isVertical offsetTop={0}>
      <KrispyTable
        numberOfLines={numberOfLines}
        padding={padding}
        layout={layout}
        striped={striped}
      >
        {children}
      </KrispyTable>
    </ContentContainer>
  );
};

Table.propTypes = propTypes;
Table.defaultProps = defaultProps;

export default Table;
